module.exports = __webpack_public_path__ + "img/26.fedd4808.jpg";